function initSlider(sectionSelector, listSelector, prevSelector, nextSelector) {
  const section = document.querySelector(sectionSelector);
  if (!section) return;

  const list = section.querySelector(listSelector);
  const prevBtn = section.querySelector(prevSelector);
  const nextBtn = section.querySelector(nextSelector);

  if (!list || !prevBtn || !nextBtn) return;

  // Тепер кнопки працюють ТІЛЬКИ якщо екран >= 1200px
  function isDesktop() {
    return window.innerWidth >= 1200;
  }

  nextBtn.addEventListener('click', () => {
    if (!isDesktop()) return;
    // scrollBy автоматично працює відносно поточного положення
    list.scrollBy({ left: list.offsetWidth, behavior: 'smooth' });
  });

  prevBtn.addEventListener('click', () => {
    if (!isDesktop()) return;
    list.scrollBy({ left: -list.offsetWidth, behavior: 'smooth' });
  });
}

initSlider(
  '.gameplay-section', 
  '.gameplay-steps', 
  '.btn-prev', 
  '.btn-next'
);
